import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,

} from "reactstrap";
import { useSelector } from "react-redux";
import PreviewComp from "../PreviewComponent/PreviewComp"

function FormPreview(props) {
  const { previewModal,requiredDoc=[], previewtoggle } = props;
  const from = useSelector((state) => state.FormReducer);
  const { formValues = [] } = from;
  return (
    <div>
      <Modal size="lg" isOpen={previewModal} toggle={previewtoggle}>
        <ModalHeader>Preview</ModalHeader>
        <ModalBody  style={{margin:"10px" }} >
<PreviewComp formValues={formValues} requiredDoc={requiredDoc}  />
        </ModalBody>
        <ModalFooter>
          <Button onClick={previewtoggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default FormPreview;
